module.exports = __webpack_public_path__ + "img/fast_food_restaurant.02de838a.png";